export default "__VITE_ASSET__6c7f7e36__"